import React from "react";
import moment from "moment/moment";
import axiosInstance from "../../../../axios";

const AnnouncementCard = ({
  element,
  deleteModal,
  setDeleteModal,
  accouncementActionHandler,
  fetchAnnouncements,
}) => {
  const { REACT_APP_PAYMENT_API_BASEURL } = process.env;
  const handleDelete = (id) => {
    axiosInstance
      .delete(`${REACT_APP_PAYMENT_API_BASEURL}/announcement/${id}`)
      .then((res) => {
        if (!res.data.error) {
          setDeleteModal({
            ...deleteModal,
            modal: false,
            id: null,
            index: null,
          });
          fetchAnnouncements();
        }
      })
      .catch((res) => {
        console.log(res);
      });
  };

  return (
    <>
      <div className="announcement-wrapper">
        {deleteModal.modal && deleteModal.index === element?.id ? (
          <div className="item-popup">
            <div className="preview-close">
              <div>
                <i className="icon check"></i>
              </div>
            </div>
            <div className="item-popup-text">
              <p>Are you really want to Delete Announcement!</p>
            </div>
            <div className="item-actions">
              <div className="margin-top-new-01-0">
                <button
                  className="lastmonth-btn-0"
                  onClick={() => handleDelete(deleteModal.id)}
                >
                  Delete
                </button>
                <button
                  className="lastmonth-btn-0"
                  onClick={() =>
                    setDeleteModal({
                      ...deleteModal,
                      modal: false,
                    })
                  }
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="announcement-main">
            <div className="announcement-heading">
              <h3>{"Attention Students !"}</h3>
              <span>{moment(element?.createdAt).format("DD/MM/YYYY")}</span>
            </div>
            <strong>
              Announcement by {element?.teacher} at{" "}
              {moment(element?.createdAt).format("dddd")}
            </strong>
            <p>{element?.description}</p>
            <button
              className="announcement-btn"
              onClick={() =>
                accouncementActionHandler(element?.description, element)
              }
            >
              Update Announcement
            </button>
            <button
              className="btn-announce"
              onClick={() =>
                setDeleteModal({
                  ...deleteModal,
                  modal: true,
                  id: element.id,
                  index: element.id,
                })
              }
            >
              Delete Announcement
            </button>
          </div>
        )}
      </div>
    </>
  );
};
export default AnnouncementCard;
